import React from 'react';
import { VerifyContact, RequireNewPassword, withAuthenticator } from 'aws-amplify-react';
import SignUp from './SignUp';
import SignIn from './SignIn';
import ConfirmSignIn from './ConfirmSignIn';
import ConfirmSignUp from './ConfirmSignUp';
import ForgotPassword from './ForgotPassword';
import AmplifyTheme from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Theme';

export function cognitoAuthentication(Component, includeGreetings = false) {
  // Custom layout for authentication form
  document.getElementById('root').style.backgroundColor = '#292F38';
  AmplifyTheme.button.backgroundColor = '#00edc3';
  AmplifyTheme.button.color = '#282f39';
  AmplifyTheme.button.borderRadius = '16px';
  AmplifyTheme.a.color = '#00edc3';
  AmplifyTheme.a.textDecoration = 'underline';

  const authenticatorComponents = [
    <ConfirmSignIn theme={AmplifyTheme} />,
    <RequireNewPassword theme={AmplifyTheme} />,
    <ConfirmSignUp theme={AmplifyTheme} />,
    <ForgotPassword theme={AmplifyTheme} />,
    <SignIn theme={AmplifyTheme} />,
    <VerifyContact theme={AmplifyTheme} />,
    <SignUp theme={AmplifyTheme} />
  ];

  return withAuthenticator(Component, includeGreetings, authenticatorComponents);
}